module.exports = __webpack_public_path__ + "static/media/clientLogo_ciroamodio.ba90db36.png";